








































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import MustUseRoleSettings from './MustUseRoleSettings.vue'
import RandomUseRoleSettings from './RandomUseRoleSettings.vue'
import TimerSettings from './TimerSettings.vue'
import OtherSettings from './OtherSettings.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

type View = 'must' | 'random' | 'timer' | 'other'

@Component({
  components: {
    MustUseRoleSettings,
    RandomUseRoleSettings,
    TimerSettings,
    OtherSettings,
    HeadlineBorder,
    BtnSquare
  }
})
export default class GameMaster extends Vue {
  @Prop() room!: Room;

  activeSettingView: View = 'must'

  changeView(view: View) {
    this.activeSettingView = view
  }
}
